// Note: Use snake_case naming conventions for build flags, so that they will be consistent
// with server-driven flag / flag overrides in the future.

import { DataSourceType } from "@coeff/api";

declare const BUILD_FLAGS: BuildFlags;

export interface BuildFlags {
  enable_gptx_functions?: boolean;
  enable_gpt_sql_builder?: boolean;
  enable_gpt_sql_builder_revamp?: boolean;
  enable_gsheets_quick_open_side_panel?: boolean;
  enable_f1_custom_functions?: boolean;
  enable_f1_custom_query_functions?: boolean;
  statsig_client_key: string;
}

export const BuildFlags = BUILD_FLAGS;
